import React from "react";
import "../App.css";

function UploadedImage({ img, imgIndex, deleteImage }) {

  const doDelete = () => {
    deleteImage(imgIndex);
  };

  return (
    <div className="imgContainer" onClick={doDelete}>
      <div
        style={{ backgroundImage: "url(" + URL.createObjectURL(img) + ")" }}
        className="uploadedImage"
        alt="Uploaded"
      />
    </div>
  );
}

export default UploadedImage;
